import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastrService } from 'ngx-toastr';

import { AddClientRequest } from '../../../../_models/customers/client/AddClientRequest';
import { UserType } from '../../../../_models/users/UserType';
import { AgentResponse } from '../../../../_models/customers/agent/AgentResponse';
import { ClientAutorisationStatus } from '../../../../_models/customers/client/ClientAutorisationStatus';

import { AgentService } from '../../../../_services/customers/agent.service';
import { AuthenticationService, ClientService } from '../../../../_services';
import { ClientType, FrenchClientType } from "../../../../_models/customers/client/ClientType";
import { JwtToken } from "../../../../_services/users/JwtToken";

@Component({
    selector: 'app-add-client',
    templateUrl: './add-client.component.html',
    styleUrls: ['./add-client.component.scss']
})
export class AddClientComponent implements OnInit {
    registerForm: UntypedFormGroup;
    submitted = false;
    selectedFiles: FileList;
    currentFileUpload: File;
    isImageSaved: boolean;
    cardImageBase64: string;
    emailCo: any;
    isLoading = false;
    commercials: AgentResponse[];
    clientTypes: ClientType[];
    selected: AgentResponse[];
    industries;
    defaultIndustrie;

    clientTypeOptions = Object.entries(FrenchClientType).map(([key, value]) => ({ label: value, value: key }));

    constructor(
        public location: Location,
        private agentService: AgentService,
        private clientService: ClientService,
        private formBuilder: UntypedFormBuilder,
        private toastr: ToastrService,
        private route: Router,
        private authenticationService: AuthenticationService,
    ) {
    }

    ngOnInit(): void {
        const user: any = this.authenticationService.userValue;
        this.agentService.getAllCommercial()
            .subscribe(
                (commercials) => this.commercials = commercials);
        this.clientService.getClientType()
            .subscribe(types => this.clientTypes = types)
        this.clientService.getIndustry()
            .subscribe(
                (res) => {
                    this.industries = res;
                    this.defaultIndustrie = this.industries.find(x => x.defaultValue = true);
                }
            )
        this.emailCo = user.email;
        this.registerForm = this.formBuilder.group({
            id: [''],
            name: ['', Validators.required],
            siren: ['', [Validators.maxLength(9), Validators.minLength(9), Validators.pattern('^[0-9]{0,}$')]],
            siret: ['', [Validators.required, Validators.maxLength(14), Validators.minLength(14), Validators.pattern('^[0-9]{0,}$')]],
            type: ['', Validators.required],
            commercial: [(user.type == UserType.AGENT_COMMERCIAL) ? user.email : '', Validators.required],
            companyName: [''],
            address1: ['', Validators.required],
            address2: [''],
            postalCode: ['', Validators.required],
            city: ['', Validators.required],
            country: [''],
            logo: [''],
            plannerId: [''],
            crmId: [''],
            industry: [(this.defaultIndustrie) ? this.defaultIndustrie.value : ''],
        });
    }

    onSelectionChanged(siret: string) {
        if (siret.length === 14) {
            console.log('yes')
            this.clientService.getBySiret(siret).subscribe(
                (res) => {
                    console.log('resultat ', res);
                    if (res) {
                        this.registerForm.patchValue({
                                name: (res.name) ? res.name : '',
                                companyName: (res.raisonSocial) ? res.raisonSocial : '',
                                address1: (res.address1) ? res.address1 : '',
                                address2: (res.address2) ? res.address2 : '',
                                postalCode: (res.postalCode) ? res.postalCode : '',
                                city: (res.city) ? res.city : '',
                                country: (res.country) ? res.country : ''
                            }
                        )
                    }
                }
            )
        }
    }

    get f() {
        return this.registerForm.controls;
    }

    goBack() {
        if (window.history.length > 1) {
            this.location.back();
        }
    }

    compareFunction(o1: any, o2: any) {
        return (o1.label === o2.label && o1.id === o2.id);
    }

    selectFile(event) {
        const file = event.target.files.item(0);
        if (file.type.match('image.*')) {
            const size = event.target.files[0].size;
            if (size > 1000000) {
                alert('size must not exceeds 1 MB');
                this.registerForm.get('profileImage').setValue('');
            } else {
                this.selectedFiles = event.target.files;
            }
        } else {
            alert('invalid format!');
        }

    }

    onSubmit() {
        this.submitted = true;
        if (this.registerForm.invalid) {
            return;
        }
        console.log('toto');
        if (this.selectedFiles) {
            this.currentFileUpload = this.selectedFiles.item(0);
            const reader = new FileReader();
            reader.onload = (e: any) => {
                const image = new Image();
                image.src = e.target.result;
                image.onload = _ => {
                    this.cardImageBase64 = e.target.result;
                    this.isImageSaved = true;
                    const addClientRequest: AddClientRequest = {
                        id: this.registerForm.value.id,
                        name: this.registerForm.value.name,
                        siren: this.registerForm.value.siren,
                        siret: this.registerForm.value.siret,
                        type: this.registerForm.value.type,
                        commercial: this.registerForm.value.commercial,
                        logo: this.cardImageBase64,
                        logoName: this.currentFileUpload.name,
                        raisonSocial: this.registerForm.value.companyName,
                        address1: this.registerForm.value.address1,
                        address2: this.registerForm.value.address2,
                        postalCode: this.registerForm.value.postalCode,
                        city: this.registerForm.value.city,
                        country: this.registerForm.value.country,
                        autorisationLevel: '',
                        autorisationStatus: ClientAutorisationStatus.NOTCERTIFIED,
                        crmId: this.registerForm.value.crmId,
                        plannerId: this.registerForm.value.plannerId,
                        industry: this.registerForm.value.industry
                    };
                    console.log('adCLientREquest', addClientRequest)
                    this.isLoading = true;
                    this.clientService.addClient(addClientRequest)
                        .subscribe(
                            _ => {
                                this.isLoading = false;
                                this.toastr.success('Client bien ajouté', '', { timeOut: 7000 });
                                void this.route.navigate(['/app']);
                            },
                            err => {
                                this.isLoading = false;
                                if (err.status)
                                    this.toastr.error(err.status, err.message, { timeOut: 15000 });
                                else
                                    this.toastr.error(err);
                                /*
                               const msg = err;
                               this.toastr.error('société '+ this.registerForm.value.siret +' est déjà enregistrée', '', {timeOut: 7000});
                               if(msg === 'USER_EXIST')
                               {
                                 this.toastr.error('société '+ this.registerForm.value.siret +' est déjà enregistrée', '', {timeOut: 7000});
                               }
                               else if (msg === 'ERROR_CREATION_IN_SALESFORCE') {
                                 this.toastr.error('échec de création du compte au niveau de Salesfoce. Le compte est bien créé au niveau de Adbot','', {timeOut: 7000})
                                 this.route.navigate(['/app']);
                               }else if( msg === 'ERROR_NATIONAL_ID_INVALID'){
                                 this.toastr.error('Siret Invalid');
                               }
                               else{
                                 this.toastr.error(err);
                               }*/
                            }
                        );
                };
            };

            reader.readAsDataURL(this.currentFileUpload);
        } else {
            const addClientRequest: AddClientRequest = {
                id: this.registerForm.value.id,
                name: this.registerForm.value.name,
                siren: this.registerForm.value.siren,
                siret: this.registerForm.value.siret,
                type: this.registerForm.value.type,
                commercial: this.registerForm.value.commercial,
                logo: null,
                logoName: null,
                raisonSocial: this.registerForm.value.companyName,
                address1: this.registerForm.value.address1,
                address2: this.registerForm.value.address2,
                postalCode: this.registerForm.value.postalCode,
                city: this.registerForm.value.city,
                country: this.registerForm.value.country,
                autorisationLevel: '',
                autorisationStatus: ClientAutorisationStatus.NOTCERTIFIED,
                crmId: this.registerForm.value.crmId,
                plannerId: this.registerForm.value.plannerId,
                industry: this.registerForm.value.industry
            };
            console.log('adCLientREquest', addClientRequest)
            this.isLoading = true;
            this.clientService.addClient(addClientRequest)
                .subscribe(
                    () => {
                        this.isLoading = false;
                        this.toastr.success('Client bien ajouté', '', { timeOut: 7000 });
                        void this.route.navigate(['/app']);
                    },
                    err => {
                        this.isLoading = false;
                        if (err.status)
                            this.toastr.error(err.status, err.message, { timeOut: 15000 });
                        else
                            this.toastr.error(err);
                        /*
                        const msg = err;
                        if(msg === 'USER_EXIST')
                        {
                          this.toastr.error('société '+ this.registerForm.value.siret +' est déjà enregistrée', '', {timeOut: 7000});
                        }
                        else if (msg === 'ERROR_CREATION_IN_SALESFORCE') {
                          this.toastr.error('échec de création du compte au niveau de Salesfoce. Le compte est bien crée au niveau de Adbot','', {timeOut: 7000})
                          this.route.navigate(['/app']);
                        }
                        else if( msg === 'ERROR_NATIONAL_ID_INVALID'){
                          this.toastr.error('Siret Invalid');
                        }
                        else{
                          this.toastr.error(err);
                        }*/
                    }
                );
        }

    }
}
